import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Item } from 'typings'
import { useFetch } from './useFetch'
import { SEARCH_TERM_PAGE_SIZE } from './utils'

type UseCollectionsReturn = Item[]

type CollectionsAPIResponse = {
  items: Array<{
    id: number
    name: string
  }>
}

const page = 1

export function useCollections(
  searchTerm: string = '',
  options?: UseQueryOptions<UseCollectionsReturn>
) {
  const { fetcherWrapper } = useFetch()

  async function fetcher(): Promise<UseCollectionsReturn> {
    const url = new URL(
      `/api/proxy/catalog_system/pvt/collection/search/${searchTerm.trim()}`,
      window.location.origin
    )

    const itemsPerPage = searchTerm ? SEARCH_TERM_PAGE_SIZE : 10

    url.search = new URLSearchParams({
      page: String(page),
      pagesize: String(itemsPerPage),
    }).toString()

    return fetcherWrapper(url)
      .then((response) => response.json())
      .then((response: CollectionsAPIResponse) =>
        response.items.map(({ id, name }) => ({ id: String(id), name }))
      )
  }

  return useQuery<UseCollectionsReturn>({
    queryKey: ['collections', searchTerm],
    queryFn: fetcher,
    retry: false,
    ...options,
  })
}
